import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Close mobile menu when location changes
  useEffect(() => {
    closeMobileMenu();
  }, [location]);

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          <img src="/CULogoTransparent.png" alt="Canadian Umbrella" className="logo-image" />
        </Link>

        <ul className="navbar-links">
          <li>
            <Link 
              to="/" 
              className={`navbar-link ${isActive('/') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Home
            </Link>
          </li>
          <li>
            <Link 
              to="/about" 
              className={`navbar-link ${isActive('/about') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              About
            </Link>
          </li>
          <li>
            <Link 
              to="/services" 
              className={`navbar-link ${isActive('/services') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Services
            </Link>
          </li>
          {/* Articles and Client Portal temporarily removed for launch */}
          <li>
            <Link 
              to="/book-consultation" 
              className={`navbar-link ${isActive('/book-consultation') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Book Consultation
            </Link>
          </li>
        </ul>

        <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
          <div className={`bar ${isMobileMenuOpen ? 'active' : ''}`}></div>
          <div className={`bar ${isMobileMenuOpen ? 'active' : ''}`}></div>
          <div className={`bar ${isMobileMenuOpen ? 'active' : ''}`}></div>
        </button>

        <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`navbar-link ${isActive('/') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={`navbar-link ${isActive('/about') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            About
          </Link>
          <Link 
            to="/services" 
            className={`navbar-link ${isActive('/services') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Services
          </Link>
          {/* Articles and Client Portal temporarily removed for launch */}
          <Link 
            to="/book-consultation" 
            className={`navbar-link ${isActive('/book-consultation') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Book Consultation
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;